import React, { useEffect, useState } from 'react'
import { Users, ClipboardList, CheckCircle2, Clock4 } from 'lucide-react'
import { useDispatch, useSelector } from 'react-redux'
import { visitorListTodo } from '../../redux/slices/visitor/VisitorList'
import dayjs from 'dayjs'
import PerfectScrollbar from 'react-perfect-scrollbar';
import 'react-perfect-scrollbar/dist/css/styles.css';
import Loader from '../../component/loader/Loader'
import { AdminDashboardTodo } from '../../redux/slices/DashboardSlice/AdminDashboard'

export default function SmartOfficeDashboard() {

    const [loading, setLoading] = useState(true)
    const dispatch = useDispatch()
    const visitors = useSelector(state => state?.visitorList?.data?.data)
    const dashboard = useSelector(state => state?.AdminDashboard?.data?.data)

    // console.log(dashboard)

    useEffect(() => {
        setLoading(true)
        dispatch(visitorListTodo({ params: { search: "", meeting_person: "", meeting_date: "", meeting_status: "", type: '' } })).then(() => setLoading(false))
        dispatch(AdminDashboardTodo()).then(() => setLoading(false))
    }, [])

    // useEffect(() => {
    //     if (!Array.isArray(visitors)) return
    //     const inside = visitors.filter(v => v?.meeting_status === 'checked_in').length
    //     const checkIns = visitors.filter(v => v?.meeting_status === 'checked_in' || v?.meeting_status === 'accepted').length
    //     const pending = visitors.filter(v => v?.meeting_status === 'pending').length
    //     const checkOuts = visitors.filter(v => v?.meeting_status === 'checked_out').length
    //     setdashboard({ visitorsInside: inside, todayCheckIns: checkIns, pendingRequests: pending, todayCheckOuts: checkOuts })
    // }, [visitors])

    const todoTasks = [
        { task: 'Approve new visitor policy', status: 'Pending' },
        { task: 'Review weekly attendance report', status: 'Completed' },
        { task: 'Confirm guest meeting slots', status: 'Pending' },
    ];

    return (
        <div className="container-fluid">
            <div className="layout_head">
                <h5>SmartOffice Dashboard</h5>
            </div>

            {/* Stats Row */}
            <div className="row mt-3">
                {/* TOTAL VISITORS */}
                <div className="col-md-3">
                    <div className="card-body main_layout">
                        <div className="d-flex align-items-center justify-content-around">
                            <div>
                                <h6 className="fw-medium dashboard_text">VISITORS INSIDE</h6>
                                <h4>{dashboard?.totalVisitorMeetingStart || 0}</h4>
                            </div>
                            <span className="icon_bg_blue">
                                <Users className="icon_blue" />
                            </span>
                        </div>
                    </div>
                </div>

                {/* TODAY CHECK-INS */}
                <div className="col-md-3">
                    <div className="card-body main_layout">
                        <div className="d-flex align-items-center justify-content-around">
                            <div>
                                <h6 className="fw-medium dashboard_text">TODAY CHECK-INS</h6>
                                <h4>{dashboard?.todayVisitorCheckIn || 0}</h4>
                            </div>
                            <span className="icon_bg_blue">
                                <ClipboardList className="icon_blue" />
                            </span>
                        </div>
                    </div>
                </div>

                {/* PENDING REQUESTS */}
                <div className="col-md-3">
                    <div className="card-body main_layout">
                        <div className="d-flex align-items-center justify-content-around">
                            <div>
                                <h6 className="fw-medium dashboard_text">PENDING REQUESTS</h6>
                                <h4>{dashboard?.pendingVisitorCheckIn || 0}</h4>
                            </div>
                            <span className="icon_bg_blue">
                                <Clock4 className="icon_blue" />
                            </span>
                        </div>
                    </div>
                </div>

                {/* TODAY CHECK-OUTS */}
                <div className="col-md-3">
                    <div className="card-body main_layout">
                        <div className="d-flex align-items-center justify-content-around">
                            <div>
                                <h6 className="fw-medium dashboard_text">TODAY CHECK-OUTS</h6>
                                <h4>{dashboard?.todayVisitorsCheckOut || 0}</h4>
                            </div>
                            <span className="icon_bg_blue">
                                <CheckCircle2 className="icon_blue" />
                            </span>
                        </div>
                    </div>
                </div>
            </div>

            {/* Visitor Log & To-Do */}
            <div className="row mt-3">
                <div className="col-md-8">
                    <div className="card-body main_layout">
                        <div className="d-flex align-items-center justify-content-between">
                            <h6 className="fw-medium dashboard_text">VMS - Visitor Log Summary</h6>
                        </div>

                        <div className="mt-3">
                            <div
                                className="table-responsive"
                                style={{ background: '#001529', borderRadius: '6px' }}
                            >
                                <PerfectScrollbar style={{ maxHeight: '70vh' }}>
                                    <table className="table table-dark table-striped mb-0">
                                        <thead>
                                            <tr>
                                                <th>Visitor</th>
                                                <th>To Meet</th>
                                                <th>Status</th>
                                                <th>Check-in</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {loading ? (
                                                <tr>
                                                    <td colSpan={4} className="text-center p-3" style={{ height: '50px' }}>
                                                        <Loader />
                                                    </td>
                                                </tr>
                                            ) : Array.isArray(visitors) && visitors.length > 0 ? (
                                                visitors.slice(0, 8).map((row, index) => {
                                                    const meeting = row?.meeting_logs?.[0] || {};
                                                    const status = meeting?.meeting_status;

                                                    return (
                                                        <tr key={index}>
                                                            <td>{row.name}</td>
                                                            <td>{meeting?.meeting_person_data?.name || '-'}</td>
                                                            <td>
                                                                <span
                                                                    className={`badge ${status === 'accepted'
                                                                        ? 'bg-primary'
                                                                        : status === 'pending'
                                                                            ? 'bg-warning'
                                                                            : status === 'rejected'
                                                                                ? 'bg-danger'
                                                                                : status === 'checked_out'
                                                                                    ? 'bg-success'
                                                                                    : 'bg-secondary'
                                                                        }`}
                                                                >
                                                                    {status
                                                                        ? status
                                                                            .split('_')
                                                                            .map((word, i) =>
                                                                                i === 0
                                                                                    ? word.charAt(0).toUpperCase() +
                                                                                    word.slice(1)
                                                                                    : word.toLowerCase()
                                                                            )
                                                                            .join(' ')
                                                                        : '-'}
                                                                </span>
                                                            </td>
                                                            <td>
                                                                {row.added_date
                                                                    ? dayjs(row.added_date).format('YYYY-MM-DD')
                                                                    : '-'}
                                                            </td>
                                                        </tr>
                                                    );
                                                })
                                            ) : (
                                                <tr>
                                                    <td colSpan={4} className="text-center">
                                                        No data
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </PerfectScrollbar>
                            </div>
                        </div>
                    </div>
                </div>


                <div className="col-md-4">
                    <div className='card-body main_layout'>
                        <h6 className='fw-medium dashboard_text'>To-Do - Today</h6>
                        <ul className='mt-3' style={{ listStyle: 'none', paddingLeft: 0 }}>
                            {todoTasks.length > 0 ? (
                                todoTasks.map((item, i) => (
                                    <li key={i} className='d-flex justify-content-between align-items-center mb-2'>
                                        <span>{item.task}</span>
                                        <span className={`badge ${item.status === 'Completed' ? 'bg-success' : 'bg-warning'}`}>
                                            {item.status}
                                        </span>
                                    </li>
                                ))
                            ) : (
                                <li className='text-center '>No tasks</li>
                            )}
                        </ul>
                    </div>
                </div>
            </div>

            {/* Reports */}
            <div className="row mt-3">
                <div className="col-md-6">
                    <div className='card-body main_layout'>
                        <h6 className='fw-medium dashboard_text'>VMS Reports</h6>
                        <p className='mb-0 mt-3 '>
                            Daily/weekly/monthly visitor traffic, peak hour analysis, and visitor type breakdown.
                        </p>
                    </div>
                </div>
                <div className="col-md-6">
                    <div className='card-body main_layout'>
                        <h6 className='fw-medium dashboard_text'>To-Do Reports</h6>
                        <p className='mb-0 mt-3 '>
                            Track task completion rates, overdue tasks, and department-wise productivity.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    )
}
